import Phaser from "phaser";
import { StartScene } from "./scenes/StartScene";
import { BOARD_IMG_WIDTH, BOARD_IMG_HEIGHT, BOARD_OFFSET_Y, UI_PANEL_HEIGHT } from "./constants";

const width = BOARD_IMG_WIDTH;
const height = BOARD_OFFSET_Y + BOARD_IMG_HEIGHT + UI_PANEL_HEIGHT;

new Phaser.Game({
  type: Phaser.AUTO,
  parent: "game",
  width,
  height,
  backgroundColor: "#1b1b1f",
  scene: [StartScene],
  scale: {
    // RESIZE: the canvas always fills the whole browser window (no letterbox
    // bars). Each scene reflows on the Scale Manager's "resize" event, scaling
    // its content to fit while the background art covers the full viewport.
    mode: Phaser.Scale.RESIZE,
  },
  render: { pixelArt: false, antialias: true },
});
